import { useCallback, useMemo } from 'react';
import { useSelector } from 'react-redux';
import { useListingLibQuickFilters } from 'framework-listing-lib/hooks/useQuickFilters';
import { IN } from 'email-management-lib/Shared/utils/filters';
// @ts-expect-error not migrated to TS yet
import { getHasCampaignsAccess } from 'EmailData/selectors/user';
import { CampaignFilter } from 'campaigns-lib';
import { PROPERTIES } from 'email-management-lib/Shared/constants/frameworkTable';
import ListingLibFilterWrapper from 'framework-listing-lib/filters/ListingLibFilterWrapper';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { jsx as _jsx } from "react/jsx-runtime";
export default function FrameworkCampaignFilter() {
  const {
    getQuickFilterValue,
    removeQuickFilter,
    setQuickFilter
  } = useListingLibQuickFilters();
  const hasCampaignsAccess = useSelector(getHasCampaignsAccess);
  const handleCampaignChange = useCallback(event => {
    const {
      value
    } = event.target;
    if (value.length === 0) {
      removeQuickFilter(PROPERTIES.CAMPAIGN_GUID);
    } else {
      setQuickFilter(IN(PROPERTIES.CAMPAIGN_GUID, value));
    }
  }, [removeQuickFilter, setQuickFilter]);
  const campaignValue = useMemo(() => {
    const value = getQuickFilterValue(PROPERTIES.CAMPAIGN_GUID, '');
    return value;
  }, [getQuickFilterValue]);
  const ButtonContent = useCallback(() => {
    const count = campaignValue ? campaignValue.length : 0;
    if (count === 0) {
      return /*#__PURE__*/_jsx(FormattedMessage, {
        message: "email-management.frameworkTable.filters.campaign.campaigns"
      });
    }
    return /*#__PURE__*/_jsx(FormattedMessage, {
      message: 'email-management.frameworkTable.filters.campaign.campaignWithCount',
      options: {
        count
      }
    });
  }, [campaignValue]);
  return /*#__PURE__*/_jsx(ListingLibFilterWrapper, {
    active: campaignValue && campaignValue.length > 0,
    onClearFilter: () => {
      removeQuickFilter(PROPERTIES.CAMPAIGN_GUID);
    },
    children: /*#__PURE__*/_jsx(CampaignFilter, {
      ButtonContent: ButtonContent,
      anchorType: "button",
      buttonUse: "transparent",
      "data-test-id": "campaign-selector",
      hasCampaignsReadAccess: hasCampaignsAccess,
      itemComponent: "span",
      multi: true,
      onChange: handleCampaignChange,
      showLabel: false,
      value: campaignValue
    })
  });
}